<template>
    <LoadingButton class="button is-glass toggleable-button2" @click="$emit('click')" :is-loading="isLoading">
        <Transition name="toggle-icon" mode="out-in">
            <span v-if="!toggled" key="default" class="button-content">
                <slot name="default"></slot>
            </span>
            <span v-else key="toggled" class="button-content toggled">
                <slot name="toggled"></slot>
            </span>
        </Transition>
    </LoadingButton>
</template>

<script setup lang="ts">
    import LoadingButton from "./LoadingButton.vue";

    defineProps<{
        isLoading?: boolean;
        toggled?: boolean;
    }>();

    defineEmits<{
        click: [];
    }>();
</script>

<style scoped></style>
